module.exports = __webpack_public_path__ + "static/media/17.33003e3f.png";